/*
 * src/components/TransferSuccess/InfoDisbursement.jsx
 * Description:
 * Copyright (c) 2021 PredictiveUX
 */
import React from 'react';

const InfoDisbursement = () => (
  <div className="create-account__line-container">
    <div className="create-account__subtitle-information">
      You should see the funds deposited into your account within the next 1-3
      business days. Check your email for a transaction summary receipt.
    </div>
  </div>
);

export default InfoDisbursement;
